
export const user_login_event = async (email, password, remember) => {
    const request_json = {
        email: email,
        password: password,
        remember: remember,
    }

    // Add your login logic here
    const response = await fetch(`/api/user/login`, {
        method: "POST",
        body: JSON.stringify(request_json),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    });
    const result = await response.json();
    const status = response.status;
    return [status, result];
}

export const user_signup_event = async (email, password, username) => {
    const request_json = {
        email: email,
        password: password,
        username: username,
    }

    // Add your login logic here
    const response = await fetch(`/api/user/register`, {
        method: "POST",
        body: JSON.stringify(request_json),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    });
    const result = await response.json();
    const status = response.status;
    return [status, result];
}

export const check_admin_event = async (accessToken) => {
    try {
        const response = await fetch(`/api/user/check_admin`, {
            method: "POST",
            headers: {
                'Authorization':  `Bearer ${accessToken}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        });
        const json = await response.json();
        if (response.status === 200) return true;
        return false;

    } catch (error) {
        return false;
    }
}

export const request_reset_password = async (email) => {
    const request_json = {
        email: email,
    }

    try {
        const response = await fetch(`/api/user/request_reset_password`, {
            method: "POST",
            body: JSON.stringify(request_json),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        });
        const result = await response.json();
        const status = response.status;
        return [status, result];

    } catch (error) {
        return [400, null];
    }
}

export const reset_password = async (id, token, password) => {
    const url = `/api/user/reset_password`;
    const request_json = {
        id: id,
        token: token,
        password: password
    };
    try {
        const response = await fetch(url, {
            method: "POST",
            body: JSON.stringify(request_json),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        });
        const result = await response.json();
        const status = response.status;
        return [status, result];

    } catch (error) {
        return [400, null];
    }
}

export const renew_access_token = async (refreshToken) => {
    const refreshResponse = await fetch('/api/user/token', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: refreshToken }),
    });

    if (refreshResponse.status === 200) {
        const { accessToken: newAccessToken } = await refreshResponse.json();
        return newAccessToken;
    }
    else {
        return null;
    }
}
